import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

const popoverMaxLength = 3;

export const TablePopover = (props) => {
  const { description, data } = props;

  if (data) {
    if (data.length > popoverMaxLength) {
      const remaining = data.length - popoverMaxLength;
      return (
        <div data-testid="table-popover">
          {data.map((child, index) => {
            if (index < popoverMaxLength) {
              return (
                <h5 key={`icon-entry-${index}`}>
                  <span className={`badge badge-secondary`}>{child.name}</span>
                </h5>
              );
            }
            return null;
          })}
          <h5 key={`icon-entry-popover`}>
            <OverlayTrigger
              placement="right"
              overlay={
                <Popover>
                  <div className="card-header">
                    {description}
                    <div className="card-header-separator-green"></div>
                  </div>
                  <div className="card-body">
                    {data.map((child, index) => {
                      if (index >= popoverMaxLength) {
                        return (
                          <h5 key={`icon-entry-${index + 1}`}>
                            <span className={`badge badge-secondary`}>
                              {child.name}
                            </span>
                          </h5>
                        );
                      }
                      return null;
                    })}
                  </div>
                </Popover>
              }
            >
              <span className="badge badge-secondary cursor-pointer">
                {`+`}
                {remaining}
              </span>
            </OverlayTrigger>
          </h5>
        </div>
      );
    } else {
      return (
        <div data-testid="table-popover">
          {data.map((child, index) => {
            return (
              <h5 key={`icon-entry-${index}`}>
                <span className={`badge badge-secondary`}>{child.name}</span>
              </h5>
            );
          })}
        </div>
      );
    }
  } else {
    return null;
  }
};
